
import { Component, Vue, Prop } from 'vue-property-decorator'
import StatusDot from '@/components/status_dot/index.vue'

@Component({
    name: 'company-auth-table',
    components: {
        StatusDot
    }
})
export default class CompanyTable extends Vue {
    @Prop({ required: true }) private value!: any[]

    private onGoDetail(company: any) {
        const href = `/enterprise/auth/${company.id}` 
        window.open(href, '_blank')
    }
}
